module.exports = __webpack_public_path__ + "static/assets/46a88a934bfa1b287dcbdbd05b6cf646.gif";